const AppAnwersByTermApplicantIdId_query = `
  query( $termApplicantId: Int!)
  {
    appAnswersBytermApplicantId(termApplicantId: $termApplicantId)
    {      
      termApplicantAnswerId
      termApplicantId{
        termApplicantId
        termId{
          termId
        }
        applicationAccepted
        applicantStatus
        applicationStatus
      }
      answerId{
        answerId
        componentId{
          componentId
        }
      }  
      applicantAnswer
      assignedScore
      awardedScore
    }
  }    
`;

const EditTermApplicantAnswer_mutate = `
  mutation editTermApplicantAnswer(
    $termApplicantAnswerId: Int!
    $termApplicantId: Int!
    $answerId: Int!
    $applicantAnswer: String!
    $assignedScore: Int!
    $awardedScore: Int!
    ) {
    editTermApplicantAnswer(
      termApplicantAnswerId: $termApplicantAnswerId,
      termApplicantId: $termApplicantId,
      answerId: $answerId,
      applicantAnswer: $applicantAnswer,
      assignedScore: $assignedScore,
      awardedScore: $awardedScore ) 
    {
      termApplicantAnswer
      {
        termApplicantAnswerId
        answerId{
          answerId
        }
        applicantAnswer
        assignedScore
        awardedScore
      }
    }
  }
`;

module.exports = {
  APPLICANT_ANSWERS_BY_TERM_APPLICANT_ID_QUERY: 
    AppAnwersByTermApplicantIdId_query,
  EDIT_TERM_APPLICANT_ANSWER_MUTATE: 
    EditTermApplicantAnswer_mutate,
};
